import { Box } from '@mui/material';
import React from 'react';
import { Definition } from '../Components/Definition';
import { Introduction } from '../Components/Introduction';
import { PageType } from '../../../utils/Pages';
import { AppHelmet } from '../../Common/AppHelmet';
import './Definitions.css';

import config from "../../../config/config.json";

export const Definitions = () => {

    const intro_heading1 = {
        start: "PLB ",
        highlight: "glossary",
        body: <>Here is a handy reference to the terminology used on the PLB Merchant Portal.</>
    };

    return (
        <>
            {AppHelmet.Add(PageType.Definitions)}
            <Introduction
                heading1={intro_heading1}
            />
            <Box className="facts_background whiteBackground" sx={{mt:'0.9375rem', mb:'2.5rem'}}>
                <div className="definitions_gridContainer">
                        <Definition
                            heading="Alcohol"
                            body={<>Alcoholic beverages and products, including home-brew kits and home-brew concentrates.</>}
                        />
                        <Definition
                            heading="Cash-like product"
                            body={<>A product that can be used like cash to gamble, buy alcohol, tobacco or tobacco products, pornography or to withdraw cash. Examples include some gift cards, prepaid cards, store credit or e-vouchers.</>}
                        />
                        <Definition
                            heading="Elibility check"
                            body={<>A set of ‘yes or no’ questions to determine whether a business sells restricted items, and if so, what methods may be available to prevent the sale of restricted items with a SmartCard.</>}
                        />
                        <Definition
                            heading="E-voucher"
                            body={<>A cash-like product that can be used as cash to purchase other goods or services and sold in fixed denominations such as $10, $20, $50 and $100.  Commonly distributed by companies such as epay Worldwide.
                                <br/><br/>E-vouchers cannot be purchased with a SmartCard if they can be used to buy alcohol, gambling services, tobacco, pornographic material or to obtain cash.</>}
                        />
                        <Definition
                            heading="Enhanced Income Management"
                            body={<>Enhanced Income Management helps customers budget their payments to meet essential household needs and expenses like food, rent, bills and education.</>}
                        />
                        <Definition
                            heading="EFTPOS terminal"
                            body={<>A card payment terminal at the point of sale which processes credit and debit card payments.</>}
                        />
                        <Definition
                            heading="Gambling"
                            body={<>Services that can be used for gambling, betting or wagering.</>}
                        />
                        <Definition
                            heading="Gift card and prepaid card"
                            body={<>A cash-like product that can be used to pay for goods and services up to the amount loaded on the card.
                            <br /><br />These cannot be purchased with a SmartCard if they can be used to buy restricted items or to obtain cash.</>}
                        />
                        <Definition
                            heading="Merchant (business)"
                            body={<>A business that sells products or services and accepts cards for payment.</>}
                        />
                        <Definition
                            heading={config.ServicesAustralia_TEAM}
                            body={<>A team within Services Australia that helps businesses understand the options for accepting SmartCard payments if they sell restricted items, answers merchant questions about the SmartCard and explains how Product Level Blocking (PLB) can work for you.</>}
                        />
                        <Definition
                            heading="Merchant Participation Agreement"
                            body={<>An agreement between a merchant and Services Australia to implement Product Level Blocking (PLB) in their business.</>}
                        />
                        <Definition
                            heading="PLB-accredited POS system"
                            body={<>A point of sale (POS) system which can automatically prevent a SmartCard paying for restricted items.</>}
                        />
                        <Definition
                            heading="Pornography"
                            body={<>Publications, computer games, or films that have been banned or censored due to the Australia Classification Board, films classified X 18+ or magazines classified Category 1 or 2 Restricted. </>}
                        />
                        <Definition
                            heading="POS operator"
                            body={<>The person operating the POS system and handling the customer sale and checkout process.</>}
                        />
                        <Definition
                            heading="POS provider or POS reseller"
                            body={<>The company that supplies the POS system to the business.</>}
                        />
                        <Definition
                            heading="Point of sale (POS) system"
                            body={<>The hardware and software used to process customer sales and manage product information in a merchant business.</>}
                        />
                        <Definition
                            heading="Product Level Blocking (PLB)"
                            body={<>A function on the POS system to ensure restricted items cannot be purchased with a SmartCard.
                                <br/><br/>The POS system and EFTPOS terminal work together to identify when a SmartCard is presented by a customer, and if there are any restricted items in the sale. </>}
                        />
                        <Definition
                            heading="Restricted items"
                            body={<>Customers cannot use their SmartCard to:
                                <ul>
                                    <li>buy tobacco or tobacco products</li>
                                    <li>buy pornography</li>
                                    <li>buy alcohol or homebrew kits/concentrates</li>
                                    <li>gamble</li>
                                    <li>buy cash-like products and some gift cards</li>
                                    <li>get cash out.</li>
                                </ul>
                                </>}
                        />
                        <Definition
                            heading="Services Australia"
                            body={<>Services Australia delivers enhanced Income Management on behalf of the Australian Government. </>}
                        />
                        <Definition
                            heading="SmartCard"
                            body={<>The SmartCard is a Visa debit card that gives customers the ability to shop online or anywhere EFTPOS is available, except places that primarily sell restricted items.</>}
                        />
                        <Definition
                            heading="Store credit"
                            body={<>Some POS systems allow customers to run credit accounts or ‘tabs’, load funds onto membership cards, or purchase vouchers for in-store credit.
                            <br /><br />The SmartCard may not be used to pay for these types of credit if the business sells alcohol, gambling services, tobacco, pornography or cash-like products.</>}
                        />
                        <Definition
                            heading="Tobacco"
                            body={<>Tobacco or tobacco products such as cigarettes, tobacco pouches, cigars or vapes.</>}
                        />
                </div>
            </Box>
        </>
    );
}
